import RealOwnerMediaContainer from './RealOwnerMediaContainer';

export default RealOwnerMediaContainer;
